/**
 * メール連携プロバイダーのブランドアイコン.
 * SVG を React コンポーネント (ReactComponent import) として使う.
 */

import type React from "react";
import { ReactComponent as GmailSvg } from "./gmail.svg";
import { ReactComponent as OutlookSvg } from "./outlook.svg";

type Props = {
  provider: string;
  size?: number;
  className?: string;
};

/**
 * プロバイダー名に応じたブランドアイコンを返す.
 * 対応外のプロバイダーは null (呼び出し側でフォールバック描画).
 * @param {Props} props provider / size / className
 * @return {JSX.Element|null} アイコン要素
 */
const ProviderIcon: React.FC<Props> = ({ provider, size = 24, className }) => {
  if (provider === "gmail") {
    return (
      <GmailSvg
        width={size}
        height={size}
        className={className}
        aria-label="Gmail"
      />
    );
  }
  if (provider === "outlook") {
    return (
      <OutlookSvg
        width={size}
        height={size}
        className={className}
        aria-label="Outlook"
      />
    );
  }
  return null;
};

export default ProviderIcon;
